import { createSlice } from '@reduxjs/toolkit'

export const initialState: any = {
  user: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  extraReducers: () => {},
})

export const { name, actions } = authSlice

const authReducer = authSlice.reducer

export default authReducer
